/** Hover highlight overlay — uses all inline styles, no CSS class needed */
export class ElementHighlight {
  private el: HTMLElement
  private label: HTMLElement

  constructor() {
    this.el = document.createElement('div')
    // All styling inline to avoid any host-page CSS interference
    Object.assign(this.el.style, {
      position: 'fixed',
      pointerEvents: 'none', // MUST be none — prevents swallowing clicks
      zIndex: '2147483644',
      border: '2px solid rgba(91,91,214,0.65)',
      background: 'rgba(91,91,214,0.08)',
      borderRadius: '3px',
      transition: 'all 0.08s cubic-bezier(0.16, 1, 0.3, 1)',
      display: 'none',
    })

    this.label = document.createElement('div')
    Object.assign(this.label.style, {
      position: 'absolute',
      top: '-22px',
      left: '0',
      background: 'rgba(91,91,214,0.88)',
      color: '#fff',
      fontSize: '10px',
      fontWeight: '600',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      padding: '2px 6px',
      borderRadius: '3px',
      whiteSpace: 'nowrap',
      lineHeight: '16px',
      pointerEvents: 'none',
      letterSpacing: '0.01em',
    })
    this.el.appendChild(this.label)

    this.el.setAttribute('data-visual-qa', 'highlight')
    const root = document.getElementById('visual-qa-root') ?? document.body
    root.appendChild(this.el)
  }

  show(el: Element): void {
    const rect = el.getBoundingClientRect()
    if (rect.width === 0 && rect.height === 0) {
      this.hide()
      return
    }

    const tag = el.tagName.toLowerCase()
    const id = el.id ? `#${el.id}` : ''
    const cls = id ? '' : Array.from(el.classList).slice(0, 2).map(c => `.${c}`).join('')
    this.label.textContent = `${tag}${id || cls}`
    // Position label below when element is near the viewport top
    this.label.style.top = rect.top < 28 ? `${rect.height + 4}px` : '-22px'

    Object.assign(this.el.style, {
      display: 'block',
      left: `${rect.left}px`,
      top: `${rect.top}px`,
      width: `${rect.width}px`,
      height: `${rect.height}px`,
    })
  }

  hide(): void {
    this.el.style.display = 'none'
  }

  destroy(): void {
    this.el.remove()
  }
}
